import { TRIPS_URL } from '@constants';
import { errorHandler, getStorageItem } from 'helpers';
import { HttpService } from 'services';

import { globalSlice } from '../global';
import { AppDispatch } from '../index';
import { schedulesSlice } from './schedulesSlice';

const getFilteredSchedules = () => {
    const storageFilters = getStorageItem('scheduleFilter') || [];
    const { setIsLoading } = globalSlice.actions;
    const { setSchedules } = schedulesSlice.actions;

    return async (dispatch: AppDispatch) => {
        dispatch(setIsLoading(true));

        try {
            const promises = storageFilters.map((filter: any) => {
                return HttpService({
                    url: `${TRIPS_URL}/?route=${filter.route}&interval=${filter.interval}&limit=200`,
                });
            });

            const results = await Promise.allSettled(promises);

            for (const result of results) {
                if (result.status === 'fulfilled') {
                    dispatch(setSchedules(result.value.data));
                } else {
                    errorHandler(result.reason, dispatch);
                }
            }

            dispatch(setIsLoading(false));

            return true;
        } catch (error) {
            errorHandler(error, dispatch);
        }

        dispatch(setIsLoading(false));
    };
};

const getVehicleById = (id: string) => {
    const { setIsLoading } = globalSlice.actions;
    const { setVehicle } = schedulesSlice.actions;

    return async (dispatch: AppDispatch) => {
        dispatch(setIsLoading(true));

        try {
            const { data } = await HttpService({
                url: `${TRIPS_URL}/vehicle/${id}`,
            });

            dispatch(setVehicle(data));
            dispatch(setIsLoading(false));

            return data;
        } catch (error) {
            errorHandler(error, dispatch);
        }

        dispatch(setIsLoading(false));
    };
};

const editTripDiscount = (trip: string, discount: number) => {
    return async (dispatch: AppDispatch) => {
        try {
            await HttpService({
                method: 'POST',
                url: `${TRIPS_URL}/discount`,
                body: { trip, discount },
            });

            return true;
        } catch (error) {
            errorHandler(error, dispatch);
        }
    };
};

const attachVehicle = (trip: string, driver: string) => {
    return async (dispatch: AppDispatch) => {
        try {
            await HttpService({
                method: 'POST',
                url: `${TRIPS_URL}/attach-vehicle`,
                body: { trip, driver },
            });

            return true;
        } catch (error) {
            errorHandler(error, dispatch);
        }
    };
};

const detachVehicle = (trip: string, driver: string) => {
    return async (dispatch: AppDispatch) => {
        try {
            await HttpService({
                method: 'POST',
                url: `${TRIPS_URL}/detach-vehicle`,
                body: { trip, driver },
            });

            return true;
        } catch (error) {
            errorHandler(error, dispatch);
        }
    };
};

export const schedulesOp = { getFilteredSchedules, editTripDiscount, attachVehicle, detachVehicle, getVehicleById };
